import React from "react"
import { ShopperInsightsSearchHitCheckout } from "lib/types/generated/graphql-types"
import InsightsCheckoutRow from "./InsightsCheckoutRow"
import {
  Container,
  CheckoutHeader,
  Section,
  TableHeader
} from "./InsightsCheckoutTable.styled"
import { CustomerOrders } from "../../classes/customer/CustomerOrders"

type Props = {
  checkouts: ShopperInsightsSearchHitCheckout[]
  customerOrders: CustomerOrders
  numberOfHits?: string
  totalCount?: number
  sidebarCollapsed: boolean
}

const InsightsCheckoutTable = ({ checkouts, customerOrders, numberOfHits, totalCount, sidebarCollapsed }: Props) => {
  if (!checkouts || checkouts.length === 0) return null

  const sortedCheckouts = checkouts
    .sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime())
    .slice(0, numberOfHits ? parseInt(numberOfHits) : checkouts.length)

  const displayTotal = totalCount ?? checkouts.length
  return (
    <Container>
      <TableHeader>
        <CheckoutHeader>Checkouts Without Orders (showing {sortedCheckouts.length} of {displayTotal})</CheckoutHeader>
        <Section className="hideOnMediumScreens">Store Group</Section>
        <Section className="hideOnSmallScreens">Store Market</Section>
        {sidebarCollapsed ?<Section className="hideOnMediumScreens">Payment Provider</Section> : <></>}
        <Section className="hideOnSmallScreens">Total</Section>
        <Section>Status</Section>
        <Section className="hideOnMediumScreens">Message</Section>
        <Section className="hideOnMediumScreens">Created</Section>
      </TableHeader>
      {sortedCheckouts.map((checkout) => (
        <InsightsCheckoutRow
          key={checkout.id}
          checkout={checkout}
          customerOrders={customerOrders}
          sidebarCollapsed={sidebarCollapsed}
        />
      ))}
    </Container>
  )
}

export default InsightsCheckoutTable
